import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

const AuditLogModule = ({ onViewLogs }) => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: 1 }}>
        <Typography variant="h6" gutterBottom>
          Audit Trail Logs
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          View and search system activity logs including user actions, timecard submissions,
          approvals, and other important events. Track changes and monitor system usage
          across the timesheet system.
        </Typography>
      </CardContent>
      <Box sx={{ p: 2, pt: 0 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onViewLogs}
        >
          View Audit Logs
        </Button>
      </Box>
    </Card>
  );
};

export default AuditLogModule;
